export default "/images/vendor/flag-icon-css/flags/4x3/la.svg?644f2f1af4cc82620b9ceaff1fe6ecce";